import { h, render, Component } from 'preact';


const linkedinIcon = (props) => (
	<svg id="in" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M17.7,69.6V24.2H3.4v45.4H17.7z M10.5,18c5,0,8.1-3.5,8.1-7.8c-0.1-4.5-3.1-7.8-8-7.8s-8.1,3.4-8.1,7.8C2.5,14.6,5.6,18,10.5,18L10.5,18z M69.5,69.6v-26c0-13.9-7.1-20.4-16.5-20.4c-7.6,0-11,4.4-12.9,7.5v-6.4H25.7c0.2,4.3,0,45.4,0,45.4H40V44.3c0-1.4,0.1-2.7,0.5-3.7c1-2.7,3.4-5.5,7.4-5.5c5.2,0,7.3,4.2,7.3,10.3v24.3L69.5,69.6L69.5,69.6z"/>
	</svg>
);

export default linkedinIcon;


// WEBPACK FOOTER //
// ../q-components/components/icons/socialIcons/linkedin/index.js